import { apiClient } from './ApiClient'
import { Organization, ApiResponse } from '../types/entities'

export class OrganizationService {
  private static readonly BASE_PATH = '/organization'

  static async getOrganizations(): Promise<Organization[]> {
    const response = await apiClient.getWithResponse<Organization[]>(this.BASE_PATH)
    return response.data
  }

  static async getOrganization(organizationId: string): Promise<Organization> {
    const response = await apiClient.getWithResponse<Organization>(`${this.BASE_PATH}/${organizationId}`)
    return response.data
  }

  static async getOrganizationsForOversight(userId: string): Promise<Organization[]> {
    const response = await apiClient.getWithResponse<Organization[]>(`${this.BASE_PATH}/oversight/${userId}`)
    return response.data
  }

  static async getUsersInOrganization(organizationId: string): Promise<any[]> {
    const response = await apiClient.getWithResponse<any[]>(`${this.BASE_PATH}/${organizationId}/users`)
    return response.data
  }

  static async createOrganization(organization: Partial<Organization>): Promise<Organization> {
    const response = await apiClient.post<ApiResponse<Organization>>(`${this.BASE_PATH}`, organization)
    return response.data
  }

  static async updateOrganization(organizationId: string, updates: Partial<Organization>): Promise<Organization> {
    const response = await apiClient.put<ApiResponse<Organization>>(`${this.BASE_PATH}/${organizationId}`, updates)
    return response.data
  }

  static async deleteOrganization(organizationId: string): Promise<void> {
    await apiClient.delete(`${this.BASE_PATH}/${organizationId}`)
  }
}